'use strict';

var modal = require('core/components/modal');
var wishlistHelpers = require('core/wishlist/components/helpers');
var recaptcha = require('core/components/recaptcha');

var MODAL_ID = 'dropAHintModal';

function clearErrors($form) {
    $form.find('.invalid-feedback').text('').hide();
    $form.find('.is-invalid').removeClass('is-invalid');
    $form.find('.drop-a-hint-message').text('').removeClass('drop-a-hint-message-error').hide();
}

function showError($form, data) {
    var $target = data.field ? $form.find('[data-field="' + data.field + '"]') : null;

    if ($target && $target.length) {
        $form.find('[name="' + data.field + '"]').addClass('is-invalid');
        $target.text(data.msg).show();
        return;
    }

    $form.find('.drop-a-hint-message').text(data.msg).addClass('drop-a-hint-message-error').show();
}

function showSuccess($container, data) {
    var $success = $container.find('.drop-a-hint-success');

    $container.find('.drop-a-hint-form').hide();
    $container.find('.drop-a-hint-product').addClass('drop-a-hint-product-compact');
    $container.find('.drop-a-hint-wishlist-suggestion').hide();
    $success.find('.drop-a-hint-success-title').text(data.title);
    $success.find('.drop-a-hint-success-text').text(data.msg);
    $success.prop('hidden', false);
}

function setLoading($form, isLoading) {
    var $button = $form.find('.drop-a-hint-submit');

    $button.prop('disabled', isLoading);
    $button.toggleClass('drop-a-hint-submit-loading', isLoading);
}

function fillModal(url, $modal) {
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            if (!data || data.error) {
                $modal.find('.modal-body').html('<p class="drop-a-hint-message drop-a-hint-message-error">' + (data && data.msg ? data.msg : '') + '</p>');
                $modal.modal('show');
                $.spinner().stop();
                return;
            }

            $modal.find('.modal-header').prepend('<h5 class="modal-title">' + data.dialogTitle + '</h5>');
            $modal.find('.modal-body').html(data.renderedTemplate);
            $modal.find('.close .sr-only').text(data.closeButtonText);
            wishlistHelpers.updateLinkData($modal.find('.wishlist-toggle-product'));
            $modal.modal('show');
            $.spinner().stop();
        },
        error: function () {
            $modal.remove();
            $.spinner().stop();
        }
    });
}

module.exports = {
    openModal: function () {
        $('body').on('click', '.btn-drop-a-hint', function (e) {
            e.preventDefault();
            $.spinner().start();
            modal.getModalHtmlElement(MODAL_ID, 'drop-a-hint-dialog');

            var $modal = $('#' + MODAL_ID).addClass('modal-drawer drop-a-hint-modal');

            fillModal($(this).data('url'), $modal);
        });
    },

    keepDrawerScrollable: function () {
        $('body').on('hidden.bs.modal', '#wishlistModalShowLists', function () {
            if ($('#' + MODAL_ID).hasClass('show')) {
                $('body').addClass('modal-open');
            }
        });
    },

    countNote: function () {
        $('body').on('input', '.drop-a-hint-note', function () {
            var $counter = $(this).closest('.form-group').find('.drop-a-hint-note-counter');
            var max = parseInt($counter.data('max'), 10);

            $counter.text($counter.text().replace(/\d+/, max - $(this).val().length));
        });
    },

    submitForm: function () {
        $('body').on('submit', '.drop-a-hint-form', function (e) {
            e.preventDefault();

            var $form = $(this);
            var $container = $form.closest('.drop-a-hint');

            clearErrors($form);
            setLoading($form, true);

            recaptcha.check(e, {
                url: $form.attr('action'),
                method: 'POST',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    setLoading($form, false);

                    if (data.success) {
                        showSuccess($container, data);
                        return;
                    }

                    showError($form, data);
                },
                error: function (err) {
                    setLoading($form, false);

                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                        return;
                    }

                    showError($form, { msg: $form.data('generic-error') || '' });
                }
            });
        });
    }
};
